import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Layout,
  Menu,
  Popconfirm,
  Row,
  Space,
  Tag,
  Tooltip,
  Typography,
} from 'antd';
import { useState } from 'react';
import {
  DeleteOutlined,
  DownloadOutlined,
  EllipsisOutlined,
  TranslationOutlined,
} from '@ant-design/icons';
import PaginatedTable from '../../components/PaginatedTable';
import FiltersTraductor from '../../components/compromisos/FiltersTraductor';
import EnvioTraducciones from '../../components/compromisos/EnvioTraducciones';
import ModalTraducir from '../../components/compromisos/traducir/ModalTraducir';

const { Content } = Layout;
const { Title } = Typography;
const { Search } = Input;

const MOCK_DATA = [
  { id: 44, nroSc: 12345, nombreSc: 'Luis Mendizabal', solicitante: 'Karen Perez', tipoCom: 'SC-SP', fechaRequerimiento: '05-10-2025', fechaEntrega: '10-10-2025', comentarios: '', estado: 'Traducida', contPreg: false, preguntas: 'Si', obsTraductor: 'La carta tiene contenido ilegible' },
  { id: 45, nroSc: 4568,  nombreSc: 'Mario Rodriguez',  solicitante: 'Karen Perez', tipoCom: 'SC-SP', fechaRequerimiento: '15-10-2025', fechaEntrega: '17-10-2025', comentarios: 'Traducir con prioridad', estado: 'Traduciendo', contPreg: false, preguntas: '', obsTraductor: '' },
  { id: 45, nroSc: 54687, nombreSc: 'Felipe Santos',    solicitante: 'Karen Perez', tipoCom: 'SC-SP', fechaRequerimiento: '15-10-2025', fechaEntrega: '17-10-2025', comentarios: 'Traducir con prioridad', estado: 'Traduciendo', contPreg: false, preguntas: '', obsTraductor: '' },
  { id: 43, nroSc: 132154,nombreSc: 'Marta Aguirre',    solicitante: 'Hilda Garcia',tipoCom: 'SC-SP', fechaRequerimiento: '15-10-2025', fechaEntrega: '17-10-2025', comentarios: 'Traducir con prioridad', estado: '',           contPreg: false, preguntas: '', obsTraductor: '' },
];

const estadoColor: Record<string, string> = {
  'Traducida':   'green',
  'Traduciendo': 'blue',
  'Pendiente':   'orange',
};

function Traductor() {

  const initialColumns = [
    { title: 'Id solic.',               dataIndex: 'id',                  key: 'id',                  visible: true,  fixed: 'left', width: 80 },
    { title: 'Nro. SC',                 dataIndex: 'nroSc',               key: 'nroSc',               visible: true,  width: 100 },
    { title: 'Nombre SC',               dataIndex: 'nombreSc',            key: 'nombreSc',            visible: true,  width: 160 },
    { title: 'Solicitante',             dataIndex: 'solicitante',         key: 'solicitante',         visible: true,  width: 140 },
    { title: 'Flujo traducción',        dataIndex: 'tipoCom',             key: 'tipoCom',             visible: true,  width: 120,
      render: (v: string) => <Tag color="purple">{v}</Tag> },
    { title: 'F. solicitud',            dataIndex: 'fechaRequerimiento',  key: 'fechaRequerimiento',  visible: true,  width: 120 },
    { title: 'F. entrega',              dataIndex: 'fechaEntrega',        key: 'fechaEntrega',        visible: true,  width: 110 },
    { title: 'F. traducido',            dataIndex: 'fechaTraducido',      key: 'fechaTraducido',      visible: true,  width: 110 },
    { title: 'Comentario a traductor',  dataIndex: 'comentarios',         key: 'comentarios',         visible: true,  width: 200 },
    { title: 'Estado',                  dataIndex: 'estado',              key: 'estado',              visible: true,  width: 120,
      render: (v: string) => v ? <Tag color={estadoColor[v] ?? 'default'}>{v}</Tag> : '-' },
    { title: 'Cont. preg?',             dataIndex: 'contPreg',            key: 'contPreg',            visible: true,  width: 100,
      render: (v: boolean) => v ? 'Si' : 'No' },
    { title: 'Preguntas SP',            dataIndex: 'preguntas',           key: 'preguntas',           visible: true,  width: 110 },
    { title: 'Obs. del traductor',      dataIndex: 'obsTraductor',        key: 'obsTraductor',        visible: true,  width: 200 },
  ];

  const [columns, setColumns]           = useState<Array<any>>(initialColumns);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [pagination] = useState({ current: 1, pageSize: 20, total: MOCK_DATA.length });
  const [openFilters, setOpenFilters]   = useState(false);
  const [filterApply, setFilterApply]   = useState<any>({});
  const [openEnvio, setOpenEnvio]         = useState(false);
  const [openTraducir, setOpenTraducir]   = useState(false);
  const [selectedRows, setSelectedRows]   = useState<any[]>([]);

  const handleVisibleChange = (e: any, key: string) => {
    setColumns(cols => cols.map(c => c.key === key ? { ...c, visible: e.target.checked } : c));
  };

  const columnMenu = (
    <Menu>
      {columns.map(c => (
        <Menu.Item key={c.key}>
          <Checkbox checked={c.visible} onChange={e => handleVisibleChange(e, c.key)}>
            {c.title}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys: React.Key[], rows: any[]) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
  };

  const visibleColumns = columns.filter(c => c.visible);

  return (
    <Layout>
      <Content>
        <Row justify="center">
          <Col span={24} className="p-1">
            <Row gutter={[20, 20]}>

              {/* Header */}
              <Col span={24}>
                <Breadcrumb>
                  <Breadcrumb.Item>Compromisos Plan</Breadcrumb.Item>
                  <Breadcrumb.Item>Compromiso 6</Breadcrumb.Item>
                  <Breadcrumb.Item>Traducción</Breadcrumb.Item>
                </Breadcrumb>
                <Title level={3}>Traducción</Title>
              </Col>

              {/* Card principal */}
              <Col span={24}>
                <Card className="border-radius">
                  <Row gutter={[10, 20]}>

                    {/* Barra de acciones */}
                    <Col span={24}>
                      <Row gutter={[10, 10]} justify="space-between" align="middle">

                        {/* Botones izquierda */}
                        <Col>
                          <Space wrap>
                            <FiltersTraductor
                              openModal={openFilters}
                              setOpenModal={setOpenFilters}
                              filterApply={filterApply}
                              onFinish={(values) => { setFilterApply(values); setOpenFilters(false); }}
                              cleanFilters={() => { setFilterApply({}); setOpenFilters(false); }}
                            />

                            <Button
                              type="primary"
                              icon={<TranslationOutlined />}
                              disabled={selectedRows.length === 0}
                              onClick={() => setOpenTraducir(true)}
                            >
                              Traducir
                            </Button>
                            <ModalTraducir
                              open={openTraducir}
                              setOpen={setOpenTraducir}
                              items={selectedRows}
                            />

                            <EnvioTraducciones
                              open={openEnvio}
                              setOpen={setOpenEnvio}
                              selectedRows={selectedRows}
                              onConfirm={() => setOpenEnvio(false)}
                            />
                          </Space>
                        </Col>

                        {/* Controles derecha */}
                        <Col>
                          <Row align="middle" gutter={[10, 10]}>
                            <Col>
                              <Search
                                placeholder="Buscar por # SC o nombre SC"
                                allowClear
                                enterButton
                                style={{ width: 280 }}
                              />
                            </Col>
                            <Col>
                              <Tooltip title="Mostrar / ocultar columnas">
                                <Dropdown trigger={['click']} overlay={columnMenu}>
                                  <Button type="primary" shape="circle" icon={<EllipsisOutlined />} />
                                </Dropdown>
                              </Tooltip>
                            </Col>
                            <Col>
                              <Tooltip title="Descargar Excel">
                                <Button icon={<DownloadOutlined />} />
                              </Tooltip>
                            </Col>
                            <Col>
                              <Popconfirm
                                title={`¿Eliminar ${selectedRowKeys.length} registro(s)?`}
                                okText="Sí"
                                cancelText="No"
                                disabled={selectedRowKeys.length === 0}
                                onConfirm={() => setSelectedRowKeys([])}
                              >
                                <Button
                                  type="primary"
                                  danger
                                  icon={<DeleteOutlined />}
                                  disabled={selectedRowKeys.length === 0}
                                >
                                  Eliminar
                                </Button>
                              </Popconfirm>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    {/* Contador de seleccionadas */}
                    {selectedRowKeys.length > 0 && (
                      <Col span={24}>
                        <b>Seleccionadas: {selectedRowKeys.length}</b>
                      </Col>
                    )}

                    {/* Tabla */}
                    <Col span={24}>
                      <PaginatedTable
                        dataSource={MOCK_DATA}
                        columns={visibleColumns}
                        rowKey="id"
                        scroll={{ x: 1600 }}
                        total={pagination.total}
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        rowSelection={{ type: 'checkbox', ...rowSelection }}
                      />
                    </Col>

                  </Row>
                </Card>
              </Col>

            </Row>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
}

export default Traductor;
